import '.as{flex-shrink:0;}.ssr-plugin'
import '.au{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.at{height:100%;}.ssr-plugin'
import '.am{border:none;}.ssr-plugin'
import '.an{background-color:transparent;}.ssr-plugin'
import '.gl{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.b0{position:sticky;}.ssr-plugin'
import '.gm{top:4rem;}.ssr-plugin'
import '.gn{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.go{padding-bottom:1rem;}.ssr-plugin'
import '.ct{margin-bottom:1rem;}.ssr-plugin'
import '.gp{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.b1{top:0px;}.ssr-plugin'
import '.bb{left:0px;}.ssr-plugin'
import '.bc{right:0px;}.ssr-plugin'
import '.bd{bottom:0px;}.ssr-plugin'
import '.dl{z-index:9999;}.ssr-plugin'
import '.dm{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.b5{justify-content:flex-end;}.ssr-plugin'
import '.av{flex:1;}.ssr-plugin'
import '.bn{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="as au l at am an gl"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a2"
    >
      <div className="b0 gm gn t go ct gp d"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="i b1 bb bc bd dl t dm d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="au d b5 gp"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="av bn">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
